// ESM-Huelle um lib/scripts/pos/receipt/CLS_CReceiptTransaction.js (Phase 4, Welle 4b).
// Prototype-Stil bleibt vorerst.

function CReceiptTransaction() {}

CReceiptTransaction.prototype.insertBon = function (Receipt) {

	var dfd = jQuery.Deferred();
	//ReceiptID
	var ReceiptTransactionClass = this;
	//Date, TAXNormal,TAXErm1,TAXErm2,TAXNull,TAXBes,TurnoverEnr,CertSerial,PosID,TurnoverCounter,SigHex,BON_ID
	var sql = "INSERT INTO BONREG (Date, TAXNormal,TAXErm1,TAXErm2,TAXNull,TAXBes,TurnoverEncr,CertSerial,PosID,TurnoverCounter,SigHex,BON_ID,ReceiptComp) " +
		"VALUES ('" + Receipt.datestr + "', " + Receipt.Normal + ", " + Receipt.Ermaessigt1 +
		", " + Receipt.Ermaessigt2 + ", " + Receipt.Null + ", " + Receipt.Besonders + ", '" + Receipt.encryptedTurnoverValue +
		"', '" + window.sigCertificateSerialNumber + "', '" + POS.POSId + "', " + window.turnovercounter + ", '" + Receipt.signatureValuePreviousReceipt +
		"', " + Receipt.BonID + ",'" + Receipt.jwsCompactRepresentation + "')";
	this.saveReceipt(Receipt);
	// Nacharbeit B Fix-Runde 1: ein Fehler kommt beim Aufrufer an (reject) - der
	// Schlussbeleg-Weg bricht dann sauber ab statt ewig zu warten.
	$.when(POS.SQLiteCon.execute(sql)).then(function () {
		dfd.resolve();
	}, function (e) { dfd.reject(e); });
	return dfd.promise();
}

CReceiptTransaction.prototype.insertFirstBon = function (Receipt) {

	var dfd = jQuery.Deferred();
	var tablename = "BONREG";
	var ReceiptTransactionClass = this;
	var sql = "SELECT Count(*) as count FROM " + tablename;
	this.saveReceipt(Receipt);
	$.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
		if (rows[0].count < 1) {

			var sql = "INSERT INTO BONREG (ReceiptID,Date, TAXNormal,TAXErm1,TAXErm2,TAXNull,TAXBes,TurnoverEncr,CertSerial,PosID,TurnoverCounter,SigHex,BON_ID,ReceiptComp) " +
				"VALUES (" + Receipt.receiptIdentifier + ",'" + Receipt.datestr + "', " + Receipt.Normal + ", " + Receipt.Ermaessigt1 +
				", " + Receipt.Ermaessigt2 + ", " + Receipt.Null + ", " + Receipt.Besonders + ", '" + Receipt.encryptedTurnoverValue +
				"', '" + window.sigCertificateSerialNumber + "', '" + POS.POSId + "', " + window.turnovercounter + ", '" + Receipt.signatureValuePreviousReceipt +
				"', " + Receipt.BonID + ",'" + Receipt.jwsCompactRepresentation + "')";
			$.when(POS.SQLiteCon.execute(sql)).then(function () {
				dfd.resolve();
			});

		}
	});
	return dfd.promise();
}

CReceiptTransaction.prototype.saveReceipt = function (Receipt) {
/*	var fh = new CFileHandler();
	fh.fileName = "var/db/Belegekompakt.txt";
	fh.appendSync(Receipt.jwsCompactRepresentation + "\n");
	fh.fileName = "var/db/qrcode.txt";
	fh.appendSync(Receipt.machineCodeRepOfReceipt + "_" + Receipt.jwsSignatureBase64 + "\n");
*/
}

CReceiptTransaction.prototype.getCompactRepresentation = function (Start,End) {

	var dfd = jQuery.Deferred();
	var tablename = "BONREG";
	var sql = "SELECT ReceiptComp from "+tablename+" where Date>'"+Start+"' and Date<'"+End+"'";
	$.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
			if (rows.length > 0) {
				dfd.resolve(rows);
			} else {
				dfd.resolve(null);
			}
	});
	return dfd.promise();
}



// DEP je Zertifikat (RKSV-Umbau): wie getCompactRepresentation, aber MIT
// ReceiptID und sortiert - eigener SQL-Text, der alte bleibt zeichengleich
// (Routing, tools/MODERNISIERUNG.md Regel 3).
CReceiptTransaction.prototype.getCompactRepresentationMitId = function (Start, End) {
	var dfd = jQuery.Deferred();
	// Grenzen EINGESCHLOSSEN: der DEP muss jeden Beleg des Bereichs enthalten -
	// "Date > T00:00:00" verlor einen Beleg genau um Mitternacht (Gate-Nachtrag).
	var sql = "SELECT ReceiptID, ReceiptComp, CertSerial FROM BONREG WHERE Date >= '" + Start + "' AND Date <= '" + End + "' ORDER BY ReceiptID";
	$.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
		dfd.resolve(rows && rows.length > 0 ? rows : null);
	});
	return dfd.promise();
}

CReceiptTransaction.prototype.readLastRecord = function () {
	var dfd = jQuery.Deferred();
	//	var BonManagerClass = this;
	$.when(POS.SQLiteCon.lastInsertBonRegId()).done(function (ID) {
		//var name = "TurnoverCounter";
		var tablename = "BONREG";
		var sql = "SELECT * from " + tablename + " where ReceiptID = " + ID;
		$.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
			if (rows.length > 0) {
				dfd.resolve(rows);
			} else {
				dfd.resolve(null);
			}
		});
	});
	return dfd.promise();
}

CReceiptTransaction.prototype.readDBtoReceiptLastRecord = function () {

	var dfd = jQuery.Deferred();
	$.when(this.readLastRecord()).done(function (rows) {
		if ((rows) && (rows.length > 0)) {
			var PrevReceipt = new CReceipt(); //keine Parameter!!!
			//ReceiptID,Date
			PrevReceipt.setParameters(rows[0].ReceiptID, rows[0].Date, rows[0].TAXNormal, rows[0].TAXErm1,
				rows[0].TAXErm2, rows[0].TAXNull, rows[0].TAXBes, rows[0].TurnoverEncr, rows[0].CertSerial, rows[0].SigHex, rows[0].ReceiptComp);
			window.turnovercounter = Number(rows[0].TurnoverCounter); // Cross-File-Global (RKSV, schreibt auch CReceipt)
			dfd.resolve(PrevReceipt);
		} else {
			dfd.resolve(null);
		}
	});
	return dfd.promise();
}

export { CReceiptTransaction };
